import { Select } from "antd";
import React, { useState, useEffect } from "react";

import { PRESENCE_STATUS_ID, PRESENCE_STATUS_LABEL } from "../../../../configs/constants";
import { checkIfPresent } from "../../utils/presence.utils";

export const HalfDayQualify = ({
  dayIndex = -1,
  indexSelected,
  updateAttendance,
  userRoleId,
  data,
  label,
  isPresent = false,
  absenceTypes = [],
  setIsModified = () => {}
}) => {
  const types = [
    { id: PRESENCE_STATUS_ID.ATTENDANCE, label: PRESENCE_STATUS_LABEL.ATTENDANCE },
    { id: PRESENCE_STATUS_ID.ABSENCE, label: PRESENCE_STATUS_LABEL.ABSENCE },
    { id: PRESENCE_STATUS_ID.VACATION, label: PRESENCE_STATUS_LABEL.VACATION },
    { id: PRESENCE_STATUS_ID.NON_WORK, label: PRESENCE_STATUS_LABEL.NON_WORK }
  ];
  const [typeId, setTypeId] = useState(data.type && data.type.id ? data.type.id : PRESENCE_STATUS_ID.ATTENDANCE);
  const initAbsenceTypeId = typeId === PRESENCE_STATUS_ID.ATTENDANCE ? null : data.data ? data.data.id : null;
  const [absenceTypeId, setAbsenceTypeId] = useState(initAbsenceTypeId);

  useEffect(() => {
    setTypeId(data.type && data.type.id ? data.type.id : PRESENCE_STATUS_ID.ATTENDANCE);
    const initAbsenceTypeId = typeId === PRESENCE_STATUS_ID.ATTENDANCE ? null : data.data ? data.data.id : null;
    setAbsenceTypeId(initAbsenceTypeId);
  }, [JSON.stringify(data)]);

  return (
    <div className="my-6 flex-col align-middle">
      <span className="font-bold py-3 mr-3">{label} : </span>
      {data.type ? (
        <Select
          value={typeId}
          style={{ width: 200 }}
          disabled={typeId === PRESENCE_STATUS_ID.VACATION}
          onChange={_typeId => {
            if (typeId === PRESENCE_STATUS_ID.ATTENDANCE && _typeId === PRESENCE_STATUS_ID.ABSENCE) {
              setIsModified(false);
            }
            setTypeId(_typeId);
            if (_typeId === PRESENCE_STATUS_ID.ATTENDANCE) {
              const params = { _id: data._id, type: { id: _typeId }, index: indexSelected };

              if (dayIndex !== -1) params.dayIndex = dayIndex;
              updateAttendance(params);
              setIsModified(true);
              setAbsenceTypeId(null);
            }
          }}
        >
          {types.map(type => (
            <Select.Option
              key={type.id}
              value={type.id}
              disabled={
                type.id === PRESENCE_STATUS_ID.VACATION ||
                (type.id === PRESENCE_STATUS_ID.ABSENCE && isPresent) ||
                type.id === PRESENCE_STATUS_ID.NON_WORK
              }
            >
              {type.label}
            </Select.Option>
          ))}
        </Select>
      ) : (
        "N/C"
      )}

      {typeId === PRESENCE_STATUS_ID.VACATION && data.data && data.data.type && (
        <div className="flex-col my-2">
          <span className="py-3 mr-3">Type de congé : </span>
          <span className="font-bold py-3 mr-3">{data.data.type.label}</span>
        </div>
      )}
      {typeId === PRESENCE_STATUS_ID.ABSENCE && (
        <div className="flex-col my-2">
          <span className="py-3 mr-3">Type d'absence : </span>
          <Select
            value={absenceTypeId}
            style={{ width: 200 }}
            onChange={absenceTypeId => {
              setAbsenceTypeId(absenceTypeId);
              const params = { _id: data._id, type: { id: typeId }, data: { id: absenceTypeId }, index: indexSelected };

              if (dayIndex !== -1) params.dayIndex = dayIndex;
              updateAttendance(params);
              setIsModified(true);
            }}
          >
            {absenceTypes
              .filter(item => userRoleId <= item.role_min)
              .map(type => (
                <Select.Option key={type.id} value={type.id}>
                  {type.label}
                </Select.Option>
              ))}
          </Select>
        </div>
      )}
    </div>
  );
};
export const PresenceModal = ({ updateAttendance, attendance = {}, closeModal, visits = [], ...props }) => {
  const afternoon = attendance.afternoon || {};
  const morning = attendance.morning || {};

  const isPresentMorning = checkIfPresent(visits, "morning");
  const isPresentAfternoon = checkIfPresent(visits, "afternoon");
  const [isModified, setIsModified] = useState(false);

  return (
    <div key={afternoon._id}>
      <HalfDayQualify
        updateAttendance={updateAttendance}
        data={morning}
        isPresent={isPresentMorning}
        setIsModified={setIsModified}
        label="Présence matin"
        {...props}
      />
      <HalfDayQualify
        updateAttendance={updateAttendance}
        data={afternoon}
        isPresent={isPresentAfternoon}
        setIsModified={setIsModified}
        label="Présence après-midi"
        {...props}
      />
      <div className="mx-auto w-half mt-5">
        {isModified ? (
          <div
            className="cursor-pointer px-6 py-2 mx-2 rounded-full bg-green-500 text-white text-center mx-auto"
            onClick={closeModal}
          >
            Ok
          </div>
        ) : (
          <div
            className="cursor-pointer px-6 py-2 mx-2 rounded-full bg-gray-500 text-white text-center mx-auto"
            onClick={closeModal}
          >
            Annuler les changements
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// src/modules/presence/presence/modals/presenceModal.js